import React from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { formatIPA, playPronunciation } from "../../flashcardUtils";

function PronunciationLine({ card, accent, compact = false, stopPropagation = false }) {
  if (!card?.ipa && !card?.audioUrl && !card?.audioUrls?.length) return null;

  return (
    <Stack direction="row" spacing={1} alignItems="center" justifyContent={compact ? "flex-start" : "center"} sx={{ mt: compact ? 0.5 : 2 }}>
      {card.ipa && (
        <Typography sx={{ color: "var(--toeic-ink-soft)", fontFamily: "var(--lingualica-font-ipa)", fontSize: compact ? 15 : { xs: 18, md: 22 }, fontWeight: 500 }}>
          {formatIPA(card.ipa)}
        </Typography>
      )}
      <IconButton
        size="small"
        onClick={(event) => {
          if (stopPropagation) event.stopPropagation();
          playPronunciation(card.front, [
            ...(card.audioUrls || []),
            card.audioUrl,
          ]);
        }}
        sx={{ color: accent, bgcolor: "#fffefd" }}
      >
        <VolumeUpIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
}

export default PronunciationLine;
